define('shared/initializer/form/newHouseAdapters/mixins/TermsAndConditions',[
    'shared/lib/RSVP',
    'shared/remote/order/current',
    'shared/remote/order/item/extra/update'
], function(
    RSVP,
    getCurrent,
    updateOrderExtraInfo
){
    var MODULE_NAME = 'shared/initilaizer/form/newHouseAdapters/mixins/TermsAndConditions';
    
    function Ctor() { }

    Ctor.prototype.doSubmit = function() {
        return getCurrent()
            .then(function(orders){
                var id;
                outer:
                for(var i = orders.length; i--;) {
                    var order = orders[i];
                    if (!order.Items) {
                        continue;
                    } 
                    for(var j = order.Items.length; j--;) {
                        var item = order.Items[j];
                        if (!item.ExtraInfo) {
                            continue;
                        }
                        if (
                            item.ExtraInfo.NeedSignTermCondition &&
                            item.ExtraInfo.NeedSignTermCondition.toLowerCase() === 'true'
                        ) {
                            id = item.OrderItem_id;
                            break outer;
                        }
                    }
                }
                if (!id) {
                    // really? how can the user land on this page then?
                    console.log(MODULE_NAME, 'Why do you even come here? You don\'t have to sign this.');
                    return RSVP.resolve();
                }
                return updateOrderExtraInfo({
                    id: id,
                    needSignTermCondition: false
                });
            });
    };

    return Ctor;
});
